module.exports = __webpack_public_path__ + "img/new-status.0135999c.svg";